import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	formControlLabelRoot: {
		marginLeft: -8
	},
	formControlLabelLabel: {
		fontSize: theme.typography.body2.fontSize
	},
	checkboxRoot: {
		padding: props => (props.gutterVertical ? 4 : 0),
		margin: '0 5px'
	}
}));
